import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';
import { t } from 'i18next';

const CreatableSelectBox = (props) => {
    const arrayType = Array.isArray(props.errors);
    const errors = [];
    const { inputProps } = props;
    const Input = (Iprops) => <components.Input {...Iprops} {...inputProps} />;
    return (
        <React.Fragment>
            {props.label && <label>{props.label}</label>}
            <CreatableSelect
                name={props.name}
                className={props.isInvalid ? 'create-input-error' : ''}
                value={props.value}
                options={props.options}
                isMulti={props.isMulti}
                isInvalid={props.isInvalid}
                onChange={(value) => props.onChange(value)}
                onBlur={() => props.onBlur()}
                placeholder={props.placeholder}
                menuPlacement="auto"
                components={{ Input }}
                isDisabled={props.isDisabled ? props.isDisabled : false}
                noOptionsMessage={() => t('noOptions')}
            />
            {props.touched && props.errors && arrayType && (
                <div className="pb-0 invalid-feedback d-block invalid-feedback">
                    {arrayType &&
                        props.errors.length > 0 &&
                        props.errors.forEach((item) => {
                            if (item && item.value) {
                                errors.push(item.value);
                            }
                        })}
                    {errors[0]}
                </div>
            )}
            {props.touched && props.errors && !arrayType && (
                <div className="pb-0 invalid-feedback d-block invalid-feedback">{props.errors}</div>
            )}
        </React.Fragment>
    );
};

export default CreatableSelectBox;
